import { combineReducers } from 'redux';
import mainReducer from '@/bit/reducers/reducers.main-reducer';
import modalsReducer from '@/bit/reducers/reducers.modals-reducer';
import headerReducer from '@/bit/reducers/reducers.header-reducer';
import devicesReducer from '@/reducers/devices'

const REDUCERS_LIST = {
  main: mainReducer,
  modals: modalsReducer,
  header: headerReducer,
  tradeIn: devicesReducer,
}

const rootReducers = () =>
  combineReducers({
    ...REDUCERS_LIST,
  });

export default rootReducers;
